import { useEffect, useState } from "react";
import { FiMoon, FiSun } from "react-icons/fi";
function ThemeToggle() {
  const [theme, setTheme] = useState(() => { try { return localStorage.getItem("research-preview-theme") === "dark" ? "dark" : "light"; } catch { return "light"; } });
  useEffect(() => { document.documentElement.dataset.theme = theme; try { localStorage.setItem("research-preview-theme", theme); } catch { /* Optional persistence. */ } }, [theme]);
  const label = `Switch to ${theme === "light" ? "dark" : "light"} theme`;
  return (
    <button className="theme-toggle" type="button" aria-label={label} title={label}
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}>
      {theme === "light"
        ? <FiMoon aria-hidden="true" focusable="false" size={20} />
        : <FiSun aria-hidden="true" focusable="false" size={20} />}
    </button>
  );
}
export default ThemeToggle;
